import { render, staticRenderFns } from "./VerificationMethodSelector.vue?vue&type=template&id=64d8774b&scoped=true&"
import script from "./VerificationMethodSelector.vue?vue&type=script&lang=js&"
export * from "./VerificationMethodSelector.vue?vue&type=script&lang=js&"
import style0 from "./VerificationMethodSelector.vue?vue&type=style&index=0&id=64d8774b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8774b",
  null
  
)

export default component.exports